export const TABLE_FILTER_HEIGHT = "2.2rem";
